import "./Sobre.css";

export function Sobre() {
  return (
    <div className="sobre">
      <h2>
        Sobre a <br />
        VitaWave
      </h2>
      <p>
        Cuidar da sua saúde e bem estar nunca foi tão fácil e acessível. Na
        VitaWave estamos comprometidos em oferecer soluções inovadoras que
        revolucionam a forma como você cuida de si mesmo. Nossa missão é tornar
        a saúde acessível a todos independentemente de sua localização ou
        circunstâncias
      </p>
    </div>
  );
}
